import { Routes } from '@angular/router';
import { AuthGuardService } from './auth/auth-guard.service';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';



export const appRoutes: Routes = [
    {path: '',  redirectTo: '/login', pathMatch: 'full' },
    
    {path: 'login', component: LoginComponent},
    {path: 'home', component: HomeComponent,canActivate:[AuthGuardService]},
    {path: '**',  redirectTo: '/login', pathMatch: 'full' },
];
